import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { HCPService } from "./hcp.service";


import { DEFAULT_PACKAGE_URL_PROVIDER } from "@angular/platform-browser-dynamic/src/compiler_factory";
import { AppConfigService } from "../../app.config";
import { DisplayModes } from "../../models/enums";
import { Specialty } from "../../models/lookups/speciality.model";
import { HCP } from "../../models/lookups/hcp.model";
import { AlertService, DialogType, MessageSeverity } from "../../services/alert.service";
import { LookupsService } from "../../services/lookups.service";
import { AppTranslationService } from "../../services/app-translation.service";
import { Page } from "../../models/page.model";
import { ModalDirective } from "ngx-bootstrap";
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { UserPharmacyService } from "../../user-pharmacy/user-pharmacy.service";
import { RepActivityApiService } from "../../rep-activities/services/rep-activity-api.service";
import { VisitsApiService } from "../../visits/services/visits-api.service";
import { HcoService } from '../../settings/components/hco/hco.service';
import { AgreementService } from "../../agreement/agreement.service";
import { AccountService } from "../../services/account.service";
import { Permission } from "../../models/permission.model";
import { SettingService } from "../../settings/components/settings/setting.service";


@Component({
  selector: "app-hcp",
  templateUrl: "./hcp.component.html",
  styleUrls: ["./hcp.component.css"]
})
export class HCPComponent implements OnInit {
  columns: any[] = [];
  showEnglishName: boolean = false;
  searchText: string;
  search: any = {};
  totalItems: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  countryId: number;
  displayMode: DisplayModes = DisplayModes.Success;
  specialities: Specialty[] = new Array<Specialty>();
  selectedSpecialities: Specialty[] = [];
  hcps: HCP[] = [];
  error: boolean;
  message: string;
  loading: boolean;
  showHcoHcp: boolean = false;
  viewOnly: boolean = false;
  myHcps: any[] = [];
  firstList: boolean = true;
  mergeMode: boolean = false;
  attachementView: boolean = false;
  selectedHcpId;
  provisionUpdate = false;
  @ViewChild('myHcpModal')
  myHcpModal: ModalDirective;

  @ViewChild("provisionMergeModal")
  provisionMergeModal: ModalDirective;

  public logo = require("../../assets/images/demo/HCP Class.png");


  @ViewChild("specialitiesSelector")
  private specialitiesSelector;

  @ViewChild("provisionModal")
  provisionModal: ModalDirective;

  @ViewChild("hcpHcoProvisionModal")
  hcpHcoProvisionModal: ModalDirective;


  @ViewChild("addHcoHcpModal")
  addHcoHcpModal: ModalDirective;

  addNew: boolean = false;
  brandMode: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;

  @ViewChild('classesModal')
  classesModal: ModalDirective;
  classesChanged = false;

  constructor(private alertService: AlertService,
    private route: ActivatedRoute, private visitService: VisitsApiService, private readonly agreementService: AgreementService,
    private lookupsService: LookupsService, private repActivityApiService: RepActivityApiService, private userPharmacyService: UserPharmacyService,
    private hcpService: HCPService, private readonly hcoService: HcoService,
    private readonly appConfig: AppConfigService, private accountService: AccountService,
    private readonly settingService: SettingService,
    private translateService: AppTranslationService,
    private router: Router) {

  }

  ngOnInit() {
    if (this.appConfig && this.appConfig.settings && this.appConfig.settings.pageSize) {
      this.pageSize = this.appConfig.settings.pageSize;
    }
    this.getSpecialities();
   
    // this.getHCPCLasses();
    this.columns = [
      { field: 'id', header: this.translateService.getTranslation("hcps.code"), width: '5%' },
      { field: 'fullName', header: this.translateService.getTranslation("Name"), width: '20%' },
      { field: 'specialityName', header: this.translateService.getTranslation("pageHeader.speciality"), width: '11%' },
      { field: 'email', header: this.translateService.getTranslation("pageHeader.email"), width: '15%' },
      { field: 'phone', header: this.translateService.getTranslation("pageHeader.phone"), width: '10%' }

    ];
    this.getEnglishNameSetting();
    this.searchHcps();
  }

  getEnglishNameSetting() {
    this.settingService.getCustomFieldLabelConfig('HCPCostumFieldLabel').subscribe(config => {
      this.showEnglishName = config.show;
      if (config.show) {
        this.columns.splice(2, 0, { field: 'englishName', header: config.label, width: '11%' });
        this.csvOptions.headers[3] = config.label;
      } else {
        this.csvOptions.headers.splice(3, 1);
      }
    });
  }

  onSearch() {
    this.currentPage = 1;
    this.searchHcps();
  }

  searchHcps() {

    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    this.displayMode = DisplayModes.Loading;
    const specialityIds = this.selectedSpecialities ? this.selectedSpecialities.map(s => s.id) : [];
    this.hcpService.SearchHCPs(this.search.searchText, 0, this.search.hcpClassId, this.pageSize, this.currentPage, 0, false, specialityIds).subscribe(response => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;

      let result = response as Page;
      this.hcps = result.items;

      this.hcps.forEach(i => { if (i.fullName && i.fullName.length > 30) { i.trimmedName = i.fullName.substring(0, 25) + '...'; } else i.trimmedName = i.fullName; });
      this.hcps.forEach(i => { if (i.email && i.email.length > 30) { i.trimmedEmail = i.email.substring(0, 25) + '...'; } else i.trimmedEmail = i.email; });

      this.totalItems = result.totalItems;
      this.countAllPages = Math.ceil(this.totalItems / 10000);
      //console.log(result);
    }, err => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }

  pageChanged(event) {
    this.currentPage = event.first / event.rows + 1;
    if (!this.firstList)
      this.searchHcps();
    else
      this.firstList = !this.firstList;


  }

  newHCO() {
    this.addNew = true;
    //this.router.navigate(["add-hcp"]);
  }


  gotoEdit(hcoId) {
    this.selectedHcpId = hcoId;
    this.addNew = true;
    //this.router.navigate(["add-hcp", hcoId]);
  }

  confirmDelete(hcpId) {
    this.selectedHcpId = hcpId;
    this.deleteModal.show();
    //this.alertService.showDialog(this.translateService.getTranslation("DeleteConfirmationMessage"), DialogType.Confirm,
    //  () => this.deleteHCP(hcpId),
    //  () => this.alertService.showMessage(this.translateService.getTranslation("OperationCancelled"), "", MessageSeverity.Default));

  }

  gotoMerge(hcpId) {
    this.selectedHcpId = hcpId;
    this.mergeMode = true;
  }

  gotoAttachements(hcpId) {
    this.selectedHcpId = hcpId;
    this.attachementView = true;
  }

  closeMerging(event) {
    this.selectedHcpId = undefined;
    this.addNew = false;
    this.brandMode = false;
    this.mergeMode = false;
    this.attachementView = false;
    if (event) {
      this.searchHcps();
    }
  }

  deleteHCP() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.hcpService.DeleteHCP(this.selectedHcpId).subscribe(() => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Default);

      this.searchHcps();
    }, () => {
      this.displayMode = DisplayModes.Success;

      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }
  getSpecialities() {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.GetAllSpecialities("").subscribe(response => {

      const results = response;
      this.specialities = results as Specialty[];
      this.displayMode = DisplayModes.Success;
      //setTimeout(() => this.specialitiesSelector.refresh());
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

  //getHCPCLasses() {
  //  this.displayMode = DisplayModes.Loading;
  //  this.hcpService.GetAllHCPClasses("").subscribe(response => {

  //    let results = response;
  //    this.hcpClasses = results as HCPClass[];
  //    this.displayMode = DisplayModes.Success;
  //   // setTimeout(() => this.hcpClassesSelector.refresh());
  //  }, err => {
  //    this.displayMode = DisplayModes.Error;
  //  });
  //}

  generateOTP(hcpId) {
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Generating"));
    this.hcpService.generateOTP(hcpId).subscribe((result) => {
      this.alertService.stopLoadingMessage();
      this.alertService.showMessage("", this.translateService.getTranslation("GeneratedSuccessfully"), MessageSeverity.Success);
      this.hcps.filter(h => h.id == hcpId)[0].otp = result as string;
    }, (err) => {
      console.log(err)
      this.alertService.stopLoadingMessage();
      this.alertService.showMessage("", this.translateService.getTranslation("FailedToGenerate"), MessageSeverity.Error);

    });
  }

  showProvisionModal() {
    this.provisionUpdate = false;
    this.provisionModal.show();
  }

  onProvisionModalHidden() {
    this.provisionUpdate = false;
  }

  showProvisionUpdateModal() {
    this.provisionUpdate = true;
    this.provisionModal.show();
  }


  downloadCSVTemplate() {
    this.hcpService.downloadCsvTemplate().subscribe(response => {
      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "HCPTemplate.csv";
      anchor.href = url;
      anchor.click();
    },
      err => { console.log(err); });
  }

  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.loading = true;
    this.error = false;
    this.message = "Loading .....";
    if (this.provisionUpdate) {
      this.hcpService.updateFromCSV(formData).subscribe(result => {
        this.loading = false;
        let res = result as any;
        if (res.isError) {
          this.error = true;
          this.message = "uploaded with error";
          this.downloadCSVTemplatErrorFile();
        }
        else
          this.message = "uploaded success";
      });
    }
    else {
      this.hcpService.uploadCsvTemplate(formData).subscribe(result => {
        this.loading = false;
        let res = result as any;
        if (res.isError) {
          this.error = true;
          this.message = "uploaded with error";
          this.downloadCSVTemplatErrorFile();
        }
        else
          this.message = "uploaded success";
      });
    }
    
  }

  downloadCSVTemplatErrorFile() {
    this.hcpService.downloadErrorFile().subscribe(response => {

      const blob = new Blob([response], { type: "text/csv" });
      console.log(blob);
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = "Error.csv";
      anchor.href = url;
      anchor.click();
      console.log(url);
      console.log(response);
      this.displayMode = DisplayModes.Success;

    },
      err => {
        console.log(err);
        this.displayMode = DisplayModes.Error;
      });
  }

  closeAdding(event) {
    this.selectedHcpId = undefined;
    this.addNew = false;
    this.brandMode = false;
    this.attachementView = false;
    if (event) {
      this.searchHcps();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  gotoManageHcpHcos(hcpId, viewOnly) {
    this.selectedHcpId = hcpId;
    this.showHcoHcp = true;
    this.viewOnly = viewOnly;
    this.addHcoHcpModal.show();
  }


  onCloseAddHcoHcpModal() {
    this.showHcoHcp = false;
    this.addHcoHcpModal.hide();
  }


  showHcpHcoProvisionModal() {
    this.hcpHcoProvisionModal.show();
  }


  onHcpHcoProvisionModalHidden() {

  }
  items: Array<any> = new Array<any>();
  currntDownloadPage = 1;
  countAllPages = 0;
  download() {

    const specialityIds = this.selectedSpecialities ? this.selectedSpecialities.map(s => s.id) : [];
    this.hcpService.SearchHCPs(this.search.searchText, 0, this.search.hcpClassId, 10000, this.currntDownloadPage, 0, true, specialityIds).subscribe(response => {

      this.displayMode = DisplayModes.Success;
      if (response != null) {
        const result = response as Page;


        this.items = this.items.concat(result.items);
        console.log(this.items)
        //this.alertService.stopLoadingMessage();
        this.currntDownloadPage++;
        if (this.currntDownloadPage <= this.countAllPages) {
          this.download()
        }
        else {
          this.currntDownloadPage = 1;
          const csvData = this.items.map(o => {
            const row: any = { id: o.id, fullName: o.fullName, specialityName: o.specialityName };
            if (this.showEnglishName) {
              row.englishName = o.englishName;
            }
            row.email = o.email;
            row.phone = o.phone;
            row.active = o.active;
            row.businessUnit = o.businessUnitName;
            row.hcpClass = o.hcpClassName;
            return row;
          });
          new AngularCsv(csvData, "HCPsList", this.csvOptions);
          this.alertService.stopLoadingMessage();
        }
      }
    }, err => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }


  downloadCSV() {
    this.items = new Array<any>();
    this.alertService.startLoadingMessage();
    this.download()

    // this.hcpService.SearchHCPs(this.search.searchText, this.specialityId, this.search.hcpClassId, 100000, 1).subscribe(response => {
    //   let result = response as Page;
    //   const csvData = result.items.map(o => {
    //     return {
    //       id: o.id, fullName: o.fullName, specialityName: o.specialityName, englishName: o.englishName, email: o.email, phone: o.phone,
    //     };

    //   });
    //   new AngularCsv(csvData, "HCPs", this.csvOptions);
    // })
    
  }

  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'HCPs :',
    useBom: true,
    noDownload: false,
    headers: ['Code', 'Name', 'Speciality', 'English Name', 'Email', 'Phone', 'Active', 'Business Unit', 'Class']
  };

  downloadLinkedHcosCSV() {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.getHcosHcps().subscribe(response => {

      let results = response;
     
      let hcpHcos = results as any[];
      const csvData = hcpHcos.filter(x => x.isApproved).map(o => {
        return {
          hcpId: o.hcpId, hcpName: o.hcpName, hcoId: o.hcoId, hcoName: o.hcoName
        };

      });

      new AngularCsv(csvData, "Linked HCOs", this.csvOptionsLinkedHcos);
      this.displayMode = DisplayModes.Success;
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

  csvOptionsLinkedHcos = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Linked HCOs :',
    useBom: true,
    noDownload: false,
    headers: ['Hcp Id', 'Hcp Name', 'Hco Id', 'Hco Name']
  };


  selectedHcp = {} as any;
  hcpActivities;
  hcpServiceRequests;
  hcpVisits;
  hcpHcos;

  hcpAgreements;
  hcpPharmaciess;
  hcpStores;
  hcpGiveaways;
  @ViewChild('hcpDetailsModal')
  hcpDetailsModal: ModalDirective;
  dateFrom: any;
  dateTo: any;
  hcpActivitiesTotlaCount: Number = 0;
  hcpServiceRequestsTotlaCount: Number = 0;
  hcpVisitsTotlaCount: Number = 0;
  hcpAgreementsTotlaCount: Number = 0;

  gotoView(hcp) {
    const today = new Date();
    this.dateFrom = new Date(
      today.getFullYear(),
      today.getMonth() - 3,
      today.getDate()
    );
    this.dateTo = new Date();

    this.selectedHcp = hcp;

    this.visitService.getTotalHcpVisitsCount(this.selectedHcp.id).subscribe(response => {
      this.hcpVisitsTotlaCount = response as Number;
    })

    this.repActivityApiService.getTotalHcpActivitiesCount(this.selectedHcp.id, true).subscribe(response => {
      this.hcpServiceRequestsTotlaCount = response as Number;
    })

    this.repActivityApiService.getTotalHcpActivitiesCount(this.selectedHcp.id, false).subscribe(response => {
      this.hcpActivitiesTotlaCount = response as Number;
    })

    this.hcoService.getHcpHcosByHcpId(this.selectedHcp.id).subscribe(response => {
      this.hcpHcos = response;
    })

    this.agreementService.getTotalHcpAgreementsCount(this.selectedHcp.id).subscribe(response => {
      this.hcpAgreementsTotlaCount = response as Number;
    })

    this.hcpDetailsModal.show();
    this.getHcpDetails();
  }

  onDateFromChanged(value: Date) {
    if (value) {
      this.dateFrom = value;
      this.getHcpDetails();
    }
  }

  onDateToChanged(value: Date) {
    if (value) {
      this.dateTo = value;
      this.getHcpDetails();
    }
  }

  getHcpDetails() {
    if (this.dateFrom && this.dateTo && this.selectedHcp) {

      this.visitService.getHcpVisits(this.dateFrom, this.dateTo, this.selectedHcp.id).subscribe(response => {
        console.log(response)

        this.hcpVisits = response;
      })

      this.repActivityApiService.getHcpActivities(this.dateFrom, this.dateTo, this.selectedHcp.id).subscribe(response => {
        console.log(response)
        let res = response as any;
        this.hcpActivities = res.filter(x => !x.isServiceRequest);
        this.hcpServiceRequests = res.filter(x => x.isServiceRequest);
      })

      this.userPharmacyService.getUserPharmacyHcoByHcpId(this.dateFrom, this.dateTo, this.selectedHcp.id).subscribe(response => {
        console.log(response)
        let res = response as any;
        this.hcpPharmaciess = res ? res.filter(x => !x.isStore) : [];
        this.hcpStores = res ? res.filter(x => x.isStore) : [];
      })

      this.agreementService.getAgreementsByHcpId(this.selectedHcp.id, this.dateFrom, this.dateTo).subscribe(response => {
        let res = response as any;
        this.hcpAgreements = res;
      })

      this.visitService.getHcpGiveaways(this.dateFrom, this.dateTo, this.selectedHcp.id).subscribe(response => {
        let res = response as any;
        this.hcpGiveaways = res;
      })

    }

  }

  gotoBrands(hcpId) {
    this.selectedHcpId = hcpId;
    this.brandMode = true;
    this.classesModal.show();
  }

  closeClasses(changed: boolean) {
    this.classesChanged = changed;
    this.classesModal.hide();
  }

  onClassesModalHidden() {
    this.brandMode = false;
    this.selectedHcpId = undefined;
    if (this.classesChanged)
      this.searchHcps();
    this.classesChanged = false;
  }

  getMyHcps() {
    this.hcoService.getAllUserHcps()
      .subscribe(response => {
        this.myHcps = response as any[]
        this.myHcpModal.show();
      }, error => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Fetch data error", "errors occured whilst fetching data please try again", MessageSeverity.Error, error);
      });
  }

  gotoCreatVisit(hcpId) {
    this.myHcpModal.hide();
    this.router.navigate([`visits`, { hcpid: hcpId }]);
  }

  get createHcp() {
    return this.accountService.userHasPermission(Permission.createHcpsPermission);
  }
  get editHcp() {
    return this.accountService.userHasPermission(Permission.editHcpsPermission);
  }
  get deleteHcp() {
    return this.accountService.userHasPermission(Permission.deleteHcpsPermission);
  }
  get provisionHcp() {
    return this.accountService.userHasPermission(Permission.provisionHcpsPermission);
  }
  get updateSheetHcp() {
    return this.accountService.userHasPermission(Permission.updateSheetHcpsPermission);
  }
  get editHcoHcp() {
    return this.accountService.userHasPermission(Permission.editHcoHcpsPermission);
  }
  get editHcpBrands() {
    return this.accountService.userHasPermission(Permission.editHcpsBrandsPermission);
  }

  get exportHcoHcps() {
    return this.accountService.userHasPermission(Permission.exportHcoHcpsPermission);
  }
  get exportHcps() {
    return this.accountService.userHasPermission(Permission.exportHcpsPermission);
  }

  get mergeHcps() {
    return this.accountService.userHasPermission(Permission.mergeHcpsPermission);
  }

  get attachementsHcps() {
    return this.accountService.userHasPermission(Permission.manageAttachementsHcpsPermission) || this.accountService.userHasPermission(Permission.viewAttachementsHcpsPermission);
  }


  addToMyList() {
    this.router.navigate(["user-hcp-requests"]);
  }

  showProvisionMergeModal() {
    this.provisionMergeModal.show();
  }

  onProvisionMergeModalHidden() {

  }
}
